export const SHOW_EPT_FEATURE_FLAG: string = 'showEasyProvisioningTool'
export const SELF_PROVISIONING_FEATURE_FLAG: string = 'FeatureCapsSelfProvisioning'
export const ENABLE_NEW_USER_EXPERIENCE: string = 'enableNewUserExperience'
export const ENABLE_NEW_INSIGHTS: string = 'enableNewInsights'
export const ENABLE_CRM_TEAMS: string = 'enableCrmTeams'
export const ENABLE_REAL_TIME_QUEUES_MANUAL_MODE: string = 'enableRTQueueManualMode'
export const ENABLE_CLIENT_CONFIGURATION: string = 'enableNewClientConfiguration'
export const ENABLE_CRM_CONFIGURATION: string = 'enableNewCRMConfiguration'
export const ENABLE_NEW_SERVER_STATUS_PAGE: string = 'enableNewServerStatusPage'
export const ENABLE_NEW_LICENSE_MANAGEMENT_PAGE: string = 'enableNewLicenseManagementPage'
export const ENABLE_NEW_LICENCE_MANAGEMENT_FAST_PROVISIONING_PAGE: string =
    'enableNewLicenceManagementFastProvisioningPage'
export const ENABLE_NEW_TELSYS_LIST_PAGE: string = 'enableNewTelsysListPage'
export const ENABLE_NEW_USERS_LIST_PAGE: string = 'enableNewUsersListPage'
export const ENABLE_NEW_CME_LIST_PAGE: string = 'enableNewCmeListPage'
export const ENABLE_NEW_AGENT_LIST_PAGE: string = 'enableNewAgentListPage'
export const ENABLE_NEW_PARTITION_LIST_PAGE: string = 'enableNewPartitionsListPage'
export const ENABLE_NEW_DEVICE_LIST_PAGE: string = 'enableNewDeviceListPage'
export const ENABLE_NEW_CODE_LIST_PAGE: string = 'enableNewCodeListPage'
export const ENABLE_NEW_AUDIT_TRAIL_PAGE: string = 'enableNewAuditTrailPage'
export const ENABLE_NEW_LOG_MANAGEMENT_PAGE: string = 'enableNewLogManagementPage'
export const ENABLE_NEW_LOGGING_SETTINGS_PAGE: string = 'enableNewLoggingSettingsPage'
export const ENABLE_NEW_RECORDING_LIST_PAGE: string = 'enableNewRecordingListPage'
export const ENABLE_NEW_DIRECTORY_LIST_PAGE: string = 'enableNewDirectoryListPage'
export const ENABLE_GITBOOK_DOC: string = 'enableGitBookDoc'
export const ENABLE_NEW_TEL_MODULE_STATUS_PAGE: string = 'enableNewTelModuleStatusPage'
export const ENABLE_NEW_DATABASE_PAGE: string = 'enableNewDatabasePage'
export const ENABLE_NEW_ADMIN_OVERVIEW: string = 'enableNewAdminOverview'
